import { StateModule } from "@/store/modules/state.module";
import { toaster } from "@/utilities/toaster";
import { assign, Machine } from "xstate";
const statesListingMachine = Machine({
    id: "stateMachine",
    context: {
        searchData: {
            page: 1,
            pageSize: 10,
            sort: {
                field: "stateName",
                type: "asc",
            },
            columnFilters: [],
        },
        ispageChanged: false,
    },
    initial: "idle",
    states: {
        idle: {
            on: {
                GETTING_STATES: { target: "gettingStates" },
            },
        },
        gettingStates: {
            invoke: {
                id: "gettingStates",
                src: (context, event) => {
                    return StateModule.GetStates(context.searchData);
                },
                onDone: { target: "loadedStates" },
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedStates: {
            on: {
                GETTING_STATES: { target: "gettingStates", actions: "assignSearchData" },
                DELETE_STATE: { target: "deleteState", actions: "ispageChanged" },
                ADD_STATE: { target: "addState" },
                EDIT_STATE: { target: "editState" },
            },
        },
        addState: {
            tags: "showAddStateModal",
            on: {
                ADDING_STATE: { target: "addingState" },
                CANCEL_STATE: { target: "loadedStates" },
            },
        },
        addingState: {
            tags: "showAddStateModal",
            invoke: {
                id: "addingState",
                src: (context, event) => {
                    return StateModule.AddState(event.state);
                },
                onDone: { target: "gettingStates", actions: "showAddMessage" },
                onError: { target: "addState" },
            },
        },
        editState: {
            tags: "showEditStateModal",
            on: {
                UPDATING_STATE: { target: "updatingState" },
                CANCEL_STATE: { target: "loadedStates" },
            },
        },
        updatingState: {
            tags: "showEditStateModal",
            invoke: {
                id: "updatingState",
                src: (context, event) => {
                    return StateModule.EditState(event.state);
                },
                onDone: { target: "gettingStates", actions: "showEditMessage" },
                onError: { target: "editState" },
            },
        },
        deleteState: {
            tags: "showDeleteStateUI",
            on: {
                DELETING_STATE: { target: "deletingState" },
                CANCEL_STATE: { target: "loadedStates" },
            },
        },
        deletingState: {
            tags: "showDeleteStateUI",
            invoke: {
                id: "deletingState",
                src: (context, event) => {
                    return StateModule.DeleteStateById(event.stateId);
                },
                onDone: { target: "gettingStates", actions: ["showSuccessMessage", "setPage"] },
                onError: { target: "loadedStates" },
            },
        },
        serviceUnavailable: {},
    },
}, {
    actions: {
        showSuccessMessage: (context, event) => {
            toaster.ShowSuccess(event.data.successMessages[0]);
        },
        assignSearchData: assign({
            searchData: (context, event) => event.searchData,
        }),
        setPage: assign({
            searchData: (context, event) => {
                if (context.ispageChanged) {
                    return {
                        ...context.searchData,
                        page: context.searchData.page - 1,
                    };
                }
                return context.searchData;
            },
        }),
        ispageChanged: assign({
            ispageChanged: (context, event) => event.ispageChanged,
        }),
        showAddMessage: (context, event) => {
            toaster.ShowSuccess("State has been created successfully.");
        },
        showEditMessage: (context, event) => {
            toaster.ShowSuccess("State has been updated successfully.");
        },
    },
    services: {},
});
export default statesListingMachine;
